import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Dashboard() {
  const { apiFetch } = useAuth();
  const [stats, setStats] = useState({
    vouchers: 0, members: 0, income: 0, expenses: 0, result: 0,
    kasseBalance: 0, bankBalance: 0
  });
  const [recentVouchers, setRecentVouchers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    apiFetch('/api/dashboard').then(data => {
      setStats({
        vouchers: data.voucher_count,
        members: data.member_count,
        income: data.income || 0,
        expenses: data.expenses || 0,
        result: data.result || 0,
        kasseBalance: data.kasse_balance || 0,
        bankBalance: data.bank_balance || 0
      });
      setRecentVouchers(data.recent_vouchers || []);
    }).catch(err => setError(err.message || 'Kunne ikke indlæse data.'));
  }, [apiFetch]);

  const fmt = (n) => new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(n);

  return (
    <div>
      <div className="page-header">
        <h1>Oversigt</h1>
        <div style={{display: 'flex', gap: '0.5rem'}}>
          <Link to="/app/hurtig" className="btn btn-success">Hurtig bogføring</Link>
          <Link to="/app/bilag/ny" className="btn btn-primary">+ Nyt bilag</Link>
        </div>
      </div>

      {error && <div className="alert alert-error" style={{marginBottom: '1rem'}}>{error}</div>}

      <div className="card-grid" style={{gridTemplateColumns: 'repeat(2, 1fr)', marginBottom: '1rem'}}>
        <div className="card balance-card">
          <div className="card-header">Kassebeholdning</div>
          <div className="card-value">{fmt(stats.kasseBalance)}</div>
        </div>
        <div className="card balance-card">
          <div className="card-header">Bank</div>
          <div className="card-value">{fmt(stats.bankBalance)}</div>
        </div>
      </div>

      <div className="card-grid">
        <div className="card">
          <div className="card-header">Antal bilag</div>
          <div className="card-value">{stats.vouchers}</div>
        </div>
        <div className="card">
          <div className="card-header">Medlemmer</div>
          <div className="card-value">{stats.members}</div>
        </div>
        <div className="card">
          <div className="card-header">Indtægter</div>
          <div className="card-value amount-positive">{fmt(stats.income)}</div>
        </div>
        <div className="card">
          <div className="card-header">Udgifter</div>
          <div className="card-value amount-negative">{fmt(stats.expenses)}</div>
        </div>
        <div className="card">
          <div className="card-header">Resultat</div>
          <div className={`card-value ${stats.result >= 0 ? 'amount-positive' : 'amount-negative'}`}>
            {fmt(stats.result)}
          </div>
        </div>
      </div>

      <h2 style={{fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.75rem'}}>Seneste bilag</h2>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Nr.</th>
              <th>Dato</th>
              <th>Beskrivelse</th>
              <th>Oprettet af</th>
            </tr>
          </thead>
          <tbody>
            {recentVouchers.length === 0 ? (
              <tr><td colSpan="4" className="text-center">Ingen bilag endnu</td></tr>
            ) : recentVouchers.map(v => (
              <tr key={v.id}>
                <td><Link to={`/app/bilag/${v.id}`}>{v.voucher_number}</Link></td>
                <td>{new Date(v.date).toLocaleDateString('da-DK')}</td>
                <td>{v.description}</td>
                <td>{v.created_by_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{display: 'flex', gap: '0.75rem', marginTop: '1.5rem'}}>
        <Link to="/app/kassekladde" className="btn btn-secondary">Se kassekladde</Link>
        <Link to="/app/import" className="btn btn-secondary">Importer fra Excel</Link>
      </div>
    </div>
  );
}
